import React from 'react'
import { t } from '../utils/i18n'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from "react-router-dom"
import { Box, Grid, Button } from '@material-ui/core'

// Services
import CandidatesService from "../services/candidates.service"

// Components
import CandidateDetails from "./CandidateDetails"
import Alert from "./Alert"

const useStyles = makeStyles(theme => ({
  root: {
    '& > .MuiGrid-root': {
      position: 'relative',
      paddingBottom: 25,
      minHeight: 40
    },
    '& ul.MuiList-padding': { padding: '5px 0' },
    '& .MuiGrid-root.MuiTypography-root': { minWidth: '40%' },
    '& h5': { fontSize: 18 }
  },
  button: {
    backgroundColor: theme.palette.mediaforta.main,
    textTransform: 'none'
  },
  save: { 
    backgroundColor: theme.palette.mediaforta.success,
    textTransform: 'none',
    marginLeft: 10
  },
  avatar: {
    width: 60,
    height: 60,
    float: 'left'
  },
  name: {
    fontSize: 24,
    fontWeight: 500,
    padding: '2px 10px 0',
    '& > * > span': {
      fontSize: 14,
      fontWeight: 300,
      display: 'block'
    }
  },
  list: { paddingBottom: 15 },
  info: { 
    fontSize: 16,
    marginBottom: 30,
    padding: 0,
    border: 0,
    '& fieldset': { borderColor: `${theme.palette.mediaforta.light} !important` },
    '& textarea': { color: theme.palette.primary.dark },
    '& > div': { width: '100%' }
  },
  status: {
    position: 'absolute',
    top: 17,
    right: 25
  }
}))

export default function CandidateDetailsOverview({candidate = {}, edit, onUpdate}) {
  const classes = useStyles()
  const history = useHistory()
  const [ isEdit, setIsEdit ] = React.useState(edit)
  const [ error, setError ] = React.useState(false)
  
  React.useEffect(() => {
    setError(false)
    if (candidate._id) setIsEdit(false)
    else setIsEdit(true)
    // eslint-disable-next-line
  }, [candidate])

  const updateCandidate = candidate => {
    CandidatesService.patch(candidate._id, candidate).then(() => {
      setIsEdit(false)
      onUpdate()
    }).catch(() => setError(true)) 
  }

  const createCandidate = candidate => {
    setError(false)
    CandidatesService.post(candidate).then(({ _id }) => history.push('/candidates/'+_id))
    .catch(() => setError(true)) 
  }
	
  return ( 
    <Box className={classes.root}>
      <Grid container spacing={1}>
        <Grid item>
          {
            candidate._id &&
            <> 
              <Button 
                color="primary" 
                className={classes.button} 
                onClick={() => history.push('/candidates/'+candidate._id+window.location.search)}
              > {t('full_profile')} </Button>
              {! isEdit && 
              <Button 
                color="primary" 
                className={classes.save} 
                onClick={() => setIsEdit(true)}
              > {t('edit')} </Button>}
            </>
          }
          {
            isEdit && 
            <Button 
              color="primary" 
              className={classes.save} 
              onClick={() => {
                if (candidate._id) return updateCandidate(candidate)
                return createCandidate(candidate)
              }}
            > {t('save')} </Button>
          }
        </Grid>
      </Grid>
      { error && <Alert severity="error">{t('fill_in_user_create_fields')}</Alert> }
   	  <CandidateDetails 
       candidate={candidate} 
       mini={true} 
       classes={classes}
       onUpdate={updateCandidate}
       edit={isEdit} />
    </Box>
  )
}